<template>
    <div class="main-content__wizzard">
        <div class="wizzard__content">
            <h2 class="wizzard__step-title" v-translate>
                What are activities (steps) towards your objective?
            </h2>
            <ul class="wizzard__steps-to-objective">
                <li v-for="(activity, index) in objective.activities" :key="index">
                    <div class="steps-to-objective__activity">
                        <div class="steps-to-objective__activity-title" style="display:inline-block;">{{activity.name}}</div>
                        <div style="display:inline-block; float:right;" v-if="!edit_activity.includes(index)">
                            <button @click="editActivity(index)" class="button button--small button--gray button--green-on-hover" v-translate>Edit</button>
                            <button @click="deleteActivity(index)" class="button button--small button--gray button--red-on-hover">X</button>
                        </div>

                        <div class="form__group" v-if="edit_activity.includes(index)">
                            <div class="form__field">
                                <input ref="input" v-model="activity.name" type="text" class="input--text">
                            </div>
                            <div>
                                <button @click="confirmEditActivity(index)" class="button button--small button--gray button--green-on-hover" v-translate>Confirm</button>
                            </div>
                        </div>
                    </div>
                </li>
                <li v-if="objective.activities.length > 0" class="steps-to-objective__finish">
                    <div class="steps-to-objective__activity-title" v-translate>Objective completed</div>
                </li>
            </ul>
            <hr>
            <!--
            <button  class="button button--gray" type="button" @click="showAddNewActivityForm = true">Add new activity</button>
            -->
            <add-activity-step @add="addActivity"/>


            <div class="form__action-buttons">
                <a href="javascript:;" class="button button--primary" @click="submit()" v-translate>
                    Next step
                </a>
                <a href="javascript:;" class="button button--transparent" @click="$emit('advance','step-1')" v-translate>
                    Previous step
                </a>
            </div>
        </div>
        <div class="wizzard__tips">
            <h2 v-translate>Quick tips</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquid aperiam eligendi eos facilis
                illo, ipsa iste, laboriosam laudantium porro qui similique, sit suscipit tempore vero voluptate.
                Eaque impedit porro quae.</p>
            <p>Ab adipisci deserunt eius expedita explicabo, facilis, in mollitia natus provident quam quisquam,
                quo reiciendis repudiandae temporibus vel velit voluptate. Adipisci ducimus eligendi itaque,
                nesciunt pariatur perferendis rerum totam voluptates.</p>
        </div>
    </div>
</template>
<script>
    import AddActivityStep from "./AddActivityStep";

    export default {
        name: 'plan-objective-step-two',
        components: {AddActivityStep},
        data() {
            return {
                showAddNewActivityForm: true,
                objective: {},
                edit_activity: []
            }
        },
        props: {
            parent_objective: {}
        },
        beforeMount() {
            this.objective = this.parent_objective
        },
        methods: {
            submit: function () {
                if (this.objective.activities.length>0) {
                    let activity_names = true
                    for (let i = 0; i < this.objective.activities.length; i++) {
                        if (!this.objective.activities[i].name.length) {
                            activity_names = false
                        }
                    }
                    if (activity_names) {
                        this.$emit('advance', 'step-3')
                    }
                }
            },
            addActivity: function(a) {
                this.objective.activities.push(a)
            },
            deleteActivity: function(a) {
                this.objective.activities.splice(a, 1)
                this.edit_activity = []
            },
            editActivity: function(a) {
                this.edit_activity.push(a)
            },
            confirmEditActivity: function(a) {
                if(this.objective.activities[a].name.length){
                    this.edit_activity = this.edit_activity.filter(function(item) {
                        return item !== a
                    })
                }
            }
        }
    }
</script>